import React from 'react';
import { useIntl } from 'react-intl';

import { TranslateMessage } from '../../Translations/TranslateMessage/TranslateMessage';
import { Button } from '../../Button/Button';
import { Modal, ModalContent, ModalFooter } from '../Modal';
import styles from './UsaTermsAndConditionsModal.module.scss';
import { ReactComponent as LogoSVG } from '../../../../assets/auth/auth-logo.svg';

interface PropTypes {
  onClose: () => void;
}

export const UsaTermsAndConditionsModal: React.FC<PropTypes> = ({
  onClose,
}) => {
  const intl = useIntl();
  const handleOnAccept = () => {
    onClose();
  };
  const contentTranslation = intl.formatMessage({
    id: 'component.UsaTermsAndConditionsModal.content',
  });
  const titleTranslation = intl.formatMessage({
    id: 'component.UsaTermsAndConditionsModal.title',
  });
  return (
    <Modal
      onClose={onClose}
      panelSize="m"
      title={<LogoSVG className={styles.logo} />}
    >
      <ModalContent>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: titleTranslation,
          }}
        />
        <div
          className={styles.container}
          dangerouslySetInnerHTML={{
            __html: contentTranslation,
          }}
        />
      </ModalContent>

      <ModalFooter>
        <Button
          onClick={onClose}
          type="primary"
          size="medium"
          label={<TranslateMessage id="general.cancel" />}
          blur
          width="200px"
        />
        <Button
          onClick={handleOnAccept}
          type="primary"
          size="medium"
          label={
            <TranslateMessage id="component.UsaTermsAndConditionsModal.accept" />
          }
          width="200px"
        />
      </ModalFooter>
    </Modal>
  );
};
